import { AxiosError } from 'axios';
import { ServerResponse, WithAuditDetails } from 'data/types';
import { History } from 'history';
import { Dispatch, Action } from 'redux';
import { RootState } from 'data/root.reducers';
import i18n from 'i18n';
import { showSuccessMessage, showError } from 'shared/toaster';
import { ThunkDispatch } from 'redux-thunk';
import { extractErrorMessage } from '../../utils';
import * as api from './periodicAudit.api';
import {
  GET_PERIODIC_AUDIT,
  UPDATE_PERIODIC_AUDIT,
  GO_TO_PERIODIC_AUDIT_EDIT,
  GO_TO_PERIODIC_AUDIT_VIEW,
  SELECT_PERIODIC_AUDIT,
  UpdatePeriodicAuditThunkAction,
  PeriodicAuditActionTypes,
  PeriodicAudit,
  SelectPeriodicAuditAction,
} from './periodicAudit.types';
import { SYSTEM, PERIODIC_AUDIT_ROUTE, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';

export function goToPeriodicAuditEdit(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_PERIODIC_AUDIT_EDIT,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PERIODIC_AUDIT_ROUTE}/edit`);
  };
}

export function goToPeriodicAuditView(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_PERIODIC_AUDIT_VIEW,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PERIODIC_AUDIT_ROUTE}`);
  };
}

export function getPeriodicAudit(
  deliveryFunctionId: string,
): PeriodicAuditActionTypes {
  return {
    type: GET_PERIODIC_AUDIT,
    payload: api.getPeriodicAudit(deliveryFunctionId),
  };
}

export function updatePeriodicAudit(
  deliveryFunctionId: string,
  body: WithAuditDetails<PeriodicAudit>,
  history: History,
): UpdatePeriodicAuditThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: UPDATE_PERIODIC_AUDIT,
        payload: api.updatePeriodicAudit(deliveryFunctionId, body),
      });
      dispatch(getPeriodicAudit(deliveryFunctionId));
      dispatch(goToPeriodicAuditView(history));
      showSuccessMessage(i18n.t('periodicAFAudit.update.success'), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('periodicAFAudit.update.failed', { error: errorMessage }));
    }
  };
}

export function selectPeriodicAudit(
  periodicAudit: PeriodicAudit[],
): SelectPeriodicAuditAction {
  return {
    type: SELECT_PERIODIC_AUDIT,
    payload: periodicAudit,
  };
}
